import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const roleTableColumns = [
    { key: "title", label: "Role",tooltip:true, maxLength: 30 },
    { key: "description", label: "Description",tooltip:true, maxLength: 70 },
]

export const categories = [
    { id: "GENERAL SETTINGS", label: "General Settings",icon: "ri-settings-line", match: ["DASHBOARD","GLOBAL","SETTINGS","MODULE MANAGEMENT"]},
    { id: "LIBRARY", label: "Library", icon: "ri-book-open-line", match: ["ROLE", "USER", "WORKFLOW", "TEMPLATE", "CRF", "CHECKLIST", "DESIGN", "ALIQUOT", "SPONSOR", "ADVERSE EVENT", "TRAINING GROUP", "PERIOD", "CODELIST", "ICF","BED MANAGEMENT"] },
    { id: "STUDY", label: "Study", icon: "ri-database-2-line", match: ["STUDY", "DOCUMENT MANAGEMENT", "WORKFLOW QUERY"] },
    { id: "VOLUNTEER", label: "Volunteer", icon: "ri-user-heart-line", match: ["VOLUNTEER", "STUDY SCREENING"] },
    { id: "CLINICAL", label: "Clinical", icon: "ri-hospital-line", match: ["STUDY DESIGN","PARTICIPANTS","SESSION PARTICIPANTS","SUBJECTS","TIME POINT","DOSING SCHEDULE","SUBJECT CHECK-IN","SUBJECT CHECK-OUT","AMBULATORY VISIT","POST STUDY ASSESSMENT","DISPATCH","STORAGE"] },
    { id: "PHARMACY", label: "Pharmacy", icon: "ri-medicine-bottle-line", match: ["IP INVENTORY", "IP STORAGE","RETENTION", "LINE CLEARANCE","DISPENSING LOG", "RETURNS LOG","TRANSFER","STOCK RECONCILIATION","DISPOSAL","SUMMARY REPORTS"] },
    { id: "LABELS", label: "Labels", icon: "ri-hospital-line", match: ["SUBJECT LABEL","SUBJECT ICARD LABEL","VACUTAINER LABEL","RIAVIAL LABEL","DISPENSING LABEL"] },
    { id: "SESSION", label: "Session", icon: "ri-hospital-line", match: ["SESSION"] },
    { id: "AUDIT TRAIL", label: "Audit Trail", icon: "ri-hospital-line", match: ["AUDIT TRAIL"] },
    ];

export const roleFormFields: FormFieldConfig[] = [
    {
      name: "title",
      label: "Role Title",
      type: "text",
      placeholder: "Enter Role Title",
      required: true,
      rules:validations.studyRole.title,
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Enter Description",
      required: true,
      rules: validations.studyRole.description,
    },
  ];